/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
// import { PostService } from "../../../Services/ConstantService";
import axios from "axios";
import { API_URL } from "../../../Services/ApiService";
import Register from "../Register/Register";
import { toastEmmit } from "../../../Helper/Toastr";
// import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from "@react-oauth/google";
import { useCart } from "../../CartContext";
import EmailVerify from "../Email-Verify/EmailVerify";
// import { jwtDecode } from "jwt-decode";

export default function Login({ reset }) {
  const navigate = useNavigate();

  const { updateCart } = useCart();

  const [RegisterModalOpen, setRegisterModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const Udata = JSON.parse(localStorage.getItem("userdata"));

  const [RememberMe, setRememberMe] = useState(Udata ? true : false);

  const [VerifyUserEmail, setVerifyUserEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [submit, setsubmit] = useState(false);

  useEffect(() => {
    formik.resetForm();

    const setdata = { email: Udata?.email, password: Udata?.password };
    formik.setValues(setdata);
  }, [reset]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      console.log(values);
      CallLoginApi(values);
      setVerifyUserEmail(values?.email);
    },
  });

  function CallLoginApi(values) {
    values.guestUserId =  localStorage.getItem("userId")|| undefined;
    setLoader(true);
    setsubmit(true);

    axios.post(API_URL.LOGIN, values).then(
      (res) => {
        console.log(res);
        setLoader(false);
        setsubmit(false);
        if (res?.data?.status === true) {
          if (res?.data?.data?.verify === false) {
            toastEmmit(
              "info",
              "Verification Otp has been sent to your email-id.Please verify your email to login"
            );
            RememberMe
              ? localStorage.setItem("userdata", JSON.stringify(values))
              : localStorage.removeItem("userdata");
            resetForm();
            document.getElementById("openverifymodal").click();
          }
          if (res?.data?.data?.isEmailverified) {
            toastEmmit("success", res?.data?.message);
            localStorage.clear();
            localStorage.setItem("token", res?.data?.data?.accessToken);
            localStorage.setItem("count", res?.data?.data?.cartCount);
            localStorage.setItem("user", res?.data?.data?.fullName);
            localStorage.setItem("profile", res?.data?.data?.profile);
            updateCart(res?.data?.data?.cartCount);
            RememberMe
              ? localStorage.setItem("userdata", JSON.stringify(values))
              : localStorage.removeItem("userdata");
            resetForm();
            const path = window.location.href;
            const newwe = path.split("#");
            navigate(newwe[1]);
            // console.log(newwe[1]);
            document.getElementById("CloseModal").click();
          }
        } else toastEmmit("error", res?.data?.message);
      },
      (err) => {
        console.log(err);
        setLoader(false);
        setsubmit(false);
        toastEmmit(
          "error",
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.message
        );
      }
    );
  }

  function LoginasGuest() {
    setLoader(true);
    axios.post(API_URL.LOGIN_AS_GUEST, "").then(
      (res) => {
        console.log(res);
        setLoader(false);
        if (res?.data?.status === true) {
          toastEmmit("success", res?.data?.message);
          localStorage.clear();
          localStorage.setItem("token", res?.data?.data?.accessToken);
          localStorage.setItem("count", res?.data?.data?.cartCount);
          localStorage.setItem("user", res?.data?.data?.fullName);
          localStorage.setItem("userId", res?.data?.data?.id);
          localStorage.setItem("userType", res?.data?.data?.userType||"");
          localStorage.setItem("profile", 'assets/img/breadcrumb/dummy-1.png');
          updateCart(res?.data?.data?.cartCount);
          localStorage.removeItem("userdata");
          resetForm();
          const path = window.location.href;
          const newwe = path.split("#");
          navigate(newwe[1]);
          // console.log(newwe[1]);
          document.getElementById("CloseModal").click();
        } else toastEmmit("error", res?.data?.message);
      },
      (err) => {
        console.log(err);
        setLoader(false);
        toastEmmit(
          "error",
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.message
        );
      }
    );
  }

  // Function to toggle RememberMe
  function toggleRememberMe() {
    setRememberMe(!RememberMe);
  }

  function resetForm() {
    formik.resetForm();
    formik.setValues({
      email: "",
      password: "",
    });
  }

  const [user, setUser] = useState([]);
  // const [profile, setProfile] = useState([]);

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
      console.log(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user && user?.access_token) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res);
          // setProfile(res.data);
          setRememberMe(false);
          localStorage.removeItem("userdata");
          resetForm();
          if (res.data?.verified_email) {
            const setdata = {
              fullName: res?.data?.name,
              email: res.data?.email,
              socialkey: res.data?.id,
              logintype: "google",
            };
            CallLoginApi(setdata);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  // const [LoginModalClose, setLoginModalClose] = useState(false);

  // function closeModalfunc() {
  //   OnModalClose(!LoginModalClose);
  // }

  //   const responseMessage = (response) => {
  //     console.log(response);
  //     const decoded = jwtDecode(response.credential);
  //     console.log(decoded);
  // };
  // const errorMessage = (error) => {
  //     console.log(error);
  // };

  return (
    <div>
      <div
        className="modal fade index"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  resetForm();
                }}
                id="CloseModal"
              />
            </div>
            <div className="modal-body popup border-0">
              <h4>Hi, Welcome Back!</h4>
              <p>
                Still don’t have an account?{" "}
                <span className="highlight">
                  <a
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    onClick={() => setRegisterModalOpen(!RegisterModalOpen)}
                  >
                    Sign up
                  </a>
                </span>
              </p>

              <form className="pt-10" onSubmit={formik.handleSubmit}>
                <div className="row justify-content-center">
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 22 }}
                    >
                      <label htmlFor="email1">
                        Email<sup className="error">*</sup>
                      </label>
                      <input
                        type="email"
                        id="email1"
                        name="email"
                        placeholder="Enter Email Address"
                        // {...formik.getFieldProps("email")}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="error mt-1">{formik.errors.email}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 10 }}
                    >
                      <label htmlFor="password1">
                        Password<sup className="error">*</sup>
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password1"
                        name="password"
                        placeholder="Your password"
                        // {...formik.getFieldProps("password")}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                      />
                      <i
                        className={
                          showPassword
                            ? "fa-regular fa-eye"
                            : "fa-regular fa-eye-slash"
                        }
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer" }}
                      />
                      {formik.touched.password && formik.errors.password ? (
                        <div className="error mt-1">
                          {formik.errors.password}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 left-section">
                      <div className="tp-contact-4__comment-agree label-2  pb-20">
                        <div className="form-check-box left">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault1"
                            checked={RememberMe}
                            onChange={toggleRememberMe}
                          />
                          <label
                            className="form-check-label text-theme"
                            htmlFor="flexCheckDefault1"
                          >
                            Keep me logged in
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 right-section">
                      <div className="tp-contact-4__comment-agree label-2 pb-20 ">
                        <div className="right text-right">
                          <Link
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModalone"
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <button
                        className={`tp-btn-lg  large head tp-contact-4__btn w-100 popup ${
                          loader ? "disabled" : ""
                        }`}
                        type="submit" 
                      >
                        {loader && submit ? (
                          <span>
                            <i className="fa fa-spinner fa-spin fa-fw"></i>
                          </span>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </div>
                   {(localStorage.getItem("userType")!=="guestLogin") &&
                     <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <button
                        className={`tp-btn-lg  large head tp-contact-4__btn w-100 popup guest ${
                          loader ? "disabled" : ""
                        }`}
                        type="button"
                        onClick={() => LoginasGuest()}
                      >
                        {loader && !submit ? (
                          <span>
                            <i className="fa fa-spinner fa-spin fa-fw"></i>
                          </span>
                        ) : (
                          "Login as Guest"
                        )}
                      </button>
                    </div>}
                  </div>

                  <div className="row pt-30 pb-40">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      {/* <GoogleLogin onSuccess={responseMessage} onError={errorMessage} /> */}
                      <img
                        className="w-100"
                        src="assets/img/blog/google1.png"
                        alt=""
                        onClick={login}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 respons-mt">
                      <img
                        className="w-100"
                        src="assets/img/blog/google2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Register
        reset={RegisterModalOpen}
        VerifyUserEmail={setVerifyUserEmail}
      />
      <EmailVerify Email={VerifyUserEmail} />
    </div>
  );
}
